<template>
  <v-img
    :src="`${require('@/assets/images/drop.png')}`"
    :lazy-src="`${require('@/assets/images/drop.png')}`"
    class="fill-height"
    center
    height="100vh"
    alt="login background"
  >
    <v-container fluid class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5" class="width-400">
          <v-card class="primary--border bg-card-color-opacity">
            <v-card-text class="text-center">
              <nuxt-link hreflang="en" to="/">
                <v-img
                  :src="require('@/assets/logos/fairplay-website-logo.png')"
                  :lazy-src="
                    require('@/assets/logos/fairplay-website-logo.png')
                  "
                  max-width="100%"
                  height="75"
                  contain
                  alt="fairplay logo"
                  class="mb-6"
                ></v-img>
              </nuxt-link>
              <v-form
                v-if="step == 'login'"
                ref="loginForm"
                v-model="valid"
                lazy-validation
                @submit.prevent="login"
              >
                <div class="d-flex align-center align-gap">
                  <!-- <v-icon class="my-1 mr-2" v-if="selectedOption === 'User ID'"
                    >mdi-account</v-icon
                  >
                  <v-icon
                    class="my-1 mr-2"
                    v-else-if="selectedOption === 'Mobile No'"
                    >mdi-cellphone</v-icon
                  > -->
                  <v-select
                    v-model="selectedOption"
                    class="select-box"
                    :items="['Mobile No', 'User ID']"
                  >
                    <template #selection="{ item }">
                      <v-list-item-content>
                        <v-icon v-if="item === 'User ID'" class="my-1 mr-2"
                          >mdi-account</v-icon
                        >
                        <v-icon v-else-if="item === 'Mobile No'"
                          >mdi-cellphone</v-icon
                        >
                      </v-list-item-content>
                    </template>
                  </v-select>

                  <!-- <v-icon class="my-1 mr-2">mdi-account</v-icon> -->
                  <!-- <LoginInputVue
                    v-if="isB2C"
                    v-model="countryCode"
                    class="mr-2 mt-n1 flex-grow-0"
                    :readonly="BDcheck"
                  /> -->
                  <!-- <country-code
                    v-if="isB2C"
                    v-model="countryCode"
                    class="mr-2 mt-n1 flex-grow-0"
                    :readonly="BDcheck"
                  /> -->
                  <v-text-field
                    v-model.trim="form.userName"
                    :label="
                      selectedOption === 'User ID'
                        ? 'Username'
                        : 'Mobile Number'
                    "
                    :type="selectedOption === 'User ID' ? 'text' : 'number'"
                    :prefix="version && version.projectCode !== 'bd' ? '' : '0'"
                    required
                    :rules="
                      version &&
                      version.projectCode &&
                      version.projectCode !== 'fps'
                        ? rules.userName
                        : rules.fpsUserName
                    "
                    class="form-input line-height input-text"
                  ></v-text-field>
                </div>
                <!-- :rules="rules.email" -->
                <!-- label="Email Or Mobile No." -->
                <!-- hint="Eg. example@email.com Or +91 9876543210" -->
                <div class="login-password">
                  <v-text-field
                    v-model="form.password"
                    prepend-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    :placeholder="$t('header.password')"
                    required
                    :rules="rules.password"
                    @click:append="showPassword = !showPassword"
                    @click="showExample = false"
                  ></v-text-field>
                </div>
                <div v-if="isB2C" class="d-flex justify-end">
                  <v-btn to="/forgot-password" class="mb-2" small text>
                    Forgot password?
                  </v-btn>
                </div>
                <!-- <recaptcha
                  v-if="domain == ['zodexchange.com' && 'playtowin.club']"
                  @error="onError"
                  @success="onSuccess"
                  @expired="onExpired"
                  style="display: none;"
                /> -->

                <div
                  class="custom-checkbox text-left ml-1"
                  :class="$breakpoint.xsOnly ? 'my-3' : 'mb-2'"
                >
                  <input
                    id="rememberMe"
                    v-model="form.checked"
                    type="checkbox"
                  />
                  <label for="rememberMe"
                    ><span class="check-box">{{
                      $t('header.remember')
                    }}</span></label
                  >
                </div>
                <recaptcha
                  v-if="captchaOn"
                  @error="onError"
                  @success="onSuccess"
                  @expired="onExpired"
                />
                <v-btn
                  id="loginBtn"
                  :disabled="!valid"
                  :loading="loading"
                  block
                  type="submit"
                  color="primary"
                  large
                >
                  {{ $t('header.login') }}
                </v-btn>
                <!-- <v-row class="mt-2">
                  <v-col>
                    <v-btn
                      v-if="
                        version &&
                        version.projectCode &&
                        version.projectCode !== 'fps'
                      "
                      to="/forgot-password"
                      small
                      text
                    >
                      {{ $t('header.forgot') }} ?
                    </v-btn>
                    <span
                      v-if="
                        getWhatsappData && getWhatsappData.isRegisterBtnOnOff
                      "
                    >
                      |
                    </span>
                    <v-btn
                      v-if="
                        getWhatsappData && getWhatsappData.isRegisterBtnOnOff
                      "
                      :to="
                        getWhatsappData.linkPage
                          ? getWhatsappData.registerBtnLink
                          : ''
                      "
                      :href="
                        !getWhatsappData.linkPage
                          ? getWhatsappData.registerBtnLink
                          : ''
                      "
                      :target="!getWhatsappData.linkPage ? '_blank' : ''"
                      small
                      text
                      @click="getJoinNowEvent()"
                      >{{ $t('section_promotion.join_now_button') }}
                    </v-btn>
                  </v-col>
                </v-row> -->
                <div _ngcontent-mte-c118="" class="login-with">
                  <div _ngcontent-mte-c118="" class="line"></div>
                  <span _ngcontent-mte-c118="">or log in with</span>
                  <div _ngcontent-mte-c118="" class="line"></div>
                </div>
                <div class="login-with-btn">
                  <v-btn
                    id="buttonDiv"
                    class="login"
                    :loading="loading"
                    block
                    type="button"
                    @click="glogin()"
                  >
                    <v-img
                      :src="require('@/assets/images/google-icon.svg')"
                      :lazy-src="require('@/assets/images/google-icon.svg')"
                      contain
                      alt="fairplay logo"
                      class="whatsup-icon"
                    ></v-img>
                    <span class="google-text">{{ $t('header.google') }}</span>
                  </v-btn>
                  <!-- <v-btn
                    id="whatsappBtn"
                    class="login"
                    :disabled="!valid"
                    :loading="loading"
                    block
                    type="button"
                    large
                    @click="walogin()"
                  >
                    <v-img
                      :src="require('@/assets/images/whatsup-icon1.svg')"
                      :lazy-src="require('@/assets/images/whatsup-icon1.svg')"
                      contain
                      alt="fairplay logo"
                      class="whatsup-icon"
                    ></v-img>
                    <span>{{ $t('header.whatsapp') }}</span>
                  </v-btn> -->
                </div>
              </v-form>

              <v-form
                v-else
                ref="confirmRegistrationForm"
                v-model="valid"
                :lazy-validation="lazy"
              >
                <v-card-text class="text-center body-1 white--text"
                  >Please check your Mobile Number for OTP.</v-card-text
                >
                <!-- <v-text-field
                  v-model="confirmForm.userName"
                  disabled
                  prepend-icon="mdi-email"
                  label="Email"
                  required
                ></v-text-field> -->
                <v-text-field
                  v-model="confirmForm.mobileNo"
                  disabled
                  prepend-icon="mdi-cellphone"
                  label="Mobile"
                  required
                ></v-text-field>

                <v-text-field
                  v-if="verifySms"
                  v-model="confirmForm.code"
                  v-mask="'######'"
                  prepend-icon="mdi-cellphone-key"
                  label="OTP"
                  required
                  type="number"
                  :rules="confirmFormRules.code"
                ></v-text-field>
                <span class="sms-not-valid">
                  {{ smsNotValid }}
                </span>
                <v-btn
                  id="confirmBtn"
                  :loading="loading"
                  rounded
                  block
                  :disabled="!valid"
                  color="primary"
                  class="mt-8"
                  @click="confirmRegristration()"
                >
                  Confirm
                </v-btn>
                <v-card-text v-if="verifySms" class="pa-0 my-2 text-center">
                  <v-btn color="primary" text @click="resendCode()"
                    >Resend OTP</v-btn
                  >
                </v-card-text>
              </v-form>

              <v-card-text
                v-if="
                  getWhatsappData &&
                  getWhatsappData.isWhatsAppNo &&
                  getWhatsappData.number &&
                  getWhatsappData.whatsAppLink
                "
                small
                class="pa-0 text-center"
              >
                <!-- :href="`https://api.whatsapp.com/send?phone=${getWhatsappData.number}`" -->
                <v-btn
                  color="green"
                  depressed
                  :href="getWhatsappData.whatsAppLink"
                  text
                  class="btn-hightlight"
                  target="_blank"
                >
                  <v-icon color="green" left>mdi-whatsapp</v-icon>
                  <span class="white--text">
                    {{ getWhatsappData.number }}
                  </span>
                  <!-- {{ $store.state.supportContact }} -->
                </v-btn>
              </v-card-text>
            </v-card-text>

            <v-card-text
              v-if="step == 'login' && isB2C"
              class="pa-0 my-2 text-center"
            >
              Not a member?
              <v-btn to="/register-revert" color="primary" text>Join Now</v-btn>
            </v-card-text>
            <nuxt-link v-if="step == 'login'" hreflang="en" :to="'/'">
              <div class="text-center my-4">{{ $t('header.guest') }}</div>
            </nuxt-link>

            <!-- <v-card-text
              v-if="step == 'confirmSignup'"
              v-else
              class="pa-0 my-2 text-center"
            >
              <v-btn color="primary" text @click="resendCode()"
                >Resend Code</v-btn
              >
            </v-card-text> -->

            <!-- <v-card-text class="pa-0 my-2 text-center">
                Powered by
                <v-img
                  :src="require('@/assets/images/betfair-logo.png')"
                  height="40"
                  max-width="100%"
                  contain
                ></v-img>
            </v-card-text> -->
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-if="domain == 'zodexchange.com'"
        align="center"
        justify="center"
        class="footer footer-login text-center black-transparent"
      >
        <v-col cols="12" sm="8" md="5">
          <nuxt-link hreflang="en" to="/aml-policies"> AML Policy </nuxt-link>
        </v-col>
      </v-row>
    </v-container>
  </v-img>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import encryptor from '~/plugins/encryption.js'
import CountryCode from '@/components/fairplay/countryCode'
import LoginInputVue from '~/components/fairplay/wallets/LoginInput.vue'
import constants from '../constant'
import recaptcha from '../recaptcha.vue'
import eventScript from '@/services/script'
import service from '../services/apiService'
import { jwtDecode } from 'jwt-decode'
import { storeUrlParams } from '~/utils/common'

// var google = window
export default {
  name: 'LoginPage',
  components: { CountryCode, LoginInputVue },
  layout: 'empty',
  data: () => ({
    setUp: process.env.setUp,
    captchaOn: constants.captchaOn,
    verifySms: constants.verifySms,
    verifyStandardOTP: constants.verifyStandardOTP,
    loading: false,
    showExample: false,
    step: 'login',
    confirmForm: {
      userName: '',
      code: ''
    },
    selectedOption: 'Mobile No',
    smsNotValid: '',
    countryCode: '',
    BDcheck: false,
    lazy: true,
    domain: process.env.DOMAIN_NAME,
    snackbar: false,
    text: '',
    timeout: 4000,
    valid: true,
    showPassword: false,
    captcha: '',
    form: { userName: '', password: '', checked: false, captcha: '' },
    siteKey: '6Lda0YwaAAAAAAYtJQ3v4x7KRRxN6NUSddcxAADd', // image
    // siteKey: '6LdBv4waAAAAABzLkb40HaXTT7LO7Pw-sPvSzuCU', // checkbox
    token: '',
    form1: { deviceId: '' },
    confirmFormRules: {
      code: [
        (v) => !!v || 'Please check your mobile number for OTP',
        (v) => !(v && v.length !== 6) || 'OTP must be of 6 characters only'
      ]
    },
    rules: {
      userName: [
        (v) => !!v || 'Email / Mobile Number is required',
        (v) =>
          !(v && v.length < 5) || 'Username must be of 5 characters or more'
      ],
      fpsUserName: [
        (v) => !!v || 'This field is required',
        (v) =>
          !(v && v.length < 5) || 'Username must be of 5 characters or more'
      ],
      password: [
        (v) => !!v || 'Password is required',
        (v) =>
          !(v && v.length < 6) || 'Password must be of 6 characters or more',
        (v) =>
          !(v && v.split(' ').join('').length < v.length) ||
          'Password cannot contain spaces!'
      ],
      captcha: [(v) => !!v || 'Captcha is required'],
      email: [
        (v) => !!v || 'Email is required',
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'Invalid Email Address'
      ]
    },
    CDN_IMG_URL: process.env.CDN_IMG_URL
  }),
  computed: {
    ...mapState({
      getWhatsappData: (state) => state.user.whatsappData
    }),
    icon() {
      if (this.selectedOption === 'User ID') {
        return 'mdi-account'
      }
      if (this.selectedOption === 'Mobile No') {
        return 'mdi-cellphone'
      }
    },
    // ...mapState('login', ['awsUrl', 'error']),
    error() {
      return this.$store.state.authenticate.error
    },
    // loginCheck() {
    //   return this.$store.state.profile.loggedIn
    // },
    readyToSubmit() {
      return this.$store.state.contest.readyToSubmit
    },
    predictions() {
      return this.$store.state.contest.predictions
    },
    ipBlock() {
      return this.$store.state.ip.blockIpData
    },
    version() {
      return this.$store.state.profile.appversion
    },
    isB2C() {
      return this.$store.state.user.isB2C
    }
  },
  async created() {
    // await this.$store.dispatch('profile/getDeploymentVersion')
    if (this.version.projectCode === 'bd') {
      this.countryCode = '880'
      this.BDcheck = true
    } else {
      this.countryCode = '91'
    }
    await this.$store.dispatch('user/getconfigs')
    // await this.$store.dispatch('user/get')
    // this.user = this.$store.state.user.data
  },
  async mounted() {
    storeUrlParams(this.$cookies)
    const favorites = JSON.parse(localStorage.getItem('favorites'))
    this.waLoginApi()
    localStorage.setItem('favorites', JSON.stringify(favorites))
    // this.blockUserIp()
    if (
      (this.$route.query.username && this.$route.query.password) ||
      this.$route.query.user
    ) {
      this.checkUserCredentialsFromURL()
    } else {
      this.checkCookie()
    }
    await this.$store.dispatch('profile/getProfile')
    if (this.loginCheck) {
      this.$router.push('/')
      return
    }
    const verifyData = this.$store.state.authenticate.error
    if (verifyData?.verifyUser && verifyData.verifyUser === true) {
      this.step = 'confirmRegistrationForm'
      this.confirmForm.mobileNo = verifyData.user.mobileNo
      this.checkVerifySmsProcess()
    } else {
      this.$router.push('/login')
      this.step = 'login'
      this.$store.commit('authenticate/set_error', null)
    }
  },
  beforeDestroy() {
    this.$store.commit('authenticate/set_error', null)
    this.step = 'login'
  },
  methods: {
    // googleLogin: function () {
    //   google.accounts.id.initialize({
    //     client_id:
    //       '380327968261-gisgbkd3s7pbriaec3t2jq10vstepmtm.apps.googleusercontent.com',
    //     // callback: this.handleCredentialResponse()
    //     callback: this.gloginPost
    //   })
    //   google.accounts.id.renderButton(
    //     document.getElementById('buttonDiv'),
    //     { theme: 'outline', size: 'large' } // customization attributes
    //   )
    //   google.accounts.id.prompt() // also display the One Tap dialog
    // },
    // handleCredentialResponse: function (response) {
    //   console.log('Encoded JWT ID token: ' + response)
    // },
    waLoginApi() {
      this.loading = true
      const waId = localStorage.getItem('waId')
      if (waId) {
        const data = {
          otp: waId,
          atag: '',
          clickId: ''
        }
        service
          .apiCallWithUserManagement('/auth/waLogin', data)
          .then(async (res) => {
            console.log('res', res)
            const token = res.headers['authorization']
            const decodedToken = jwtDecode(token)
            this.createOneSignalUser(decodedToken, false)
            if (res?.data.status.statusCode == '0') {
              localStorage.setItem('userData', JSON.stringify(res?.data.result))
              localStorage.setItem('loginName', res?.data.result.loginName)
              localStorage.setItem('Member_code', res?.data.result.memberCode)
              localStorage.setItem(
                'betstack',
                res?.data?.result?.settings.presetStakeSettings?.settings
              )
              await this.allProcess(res)
              window.location.href = '/'
              localStorage.clear('waId')
              this.loading = false
            }
          })
          .catch((err) => {
            console.log('from walogin fn', err)
            this.loading = false
          })
      } else {
        localStorage.clear()
        sessionStorage.clear()
        this.loading = false
      }
    },
    walogin(byClick = true) {
      const url = `https://fairplay.authlink.me/?redirectUri=${window.location.origin}`
      if (byClick) {
        window.location.href = url
      }
    },
    createOneSignalUser(data, sms = true) {
      if (data) {
        try {
          const options = {
            method: 'POST',
            headers: {
              accept: 'application/json',
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              properties: {},
              subscriptions: [
                {
                  type: sms ? 'SMS' : 'Email',
                  token: sms
                    ? data?.loginName?.replace('b06.', '+')?.replace('_', '')
                    : data?.loginName?.replace('b06.', ''),
                  enabled: true
                }
              ],
              identity: { external_id: data.memberCode }
            })
          }

          fetch(
            'https://onesignal.com/api/v1/apps/9663e8d6-d33c-4c99-ab68-be0e94b29c41/users',
            options
          )
            .then((response) => response.json())
            .then((response) => console.log(response))
            .catch((err) => console.error(err))
        } catch (e) {
          console.log('ONESIGNAL user creating error: ', e)
        }
      }
    },
    glogin() {
      let atag = ''
      let clickId = ''
      // const url = 'https://dev.gemexch.co/api/auth/glogin'
      const gLoginEventId = 'sCuqgYgrbu'
      this.$store.dispatch(
        'userBalance/saveEventIdToLocalStorage',
        gLoginEventId
      )
      google.accounts.id.initialize({
        client_id:
          '296861343087-q4lf8dcfnbb76glmiaihpqumrgebij13.apps.googleusercontent.com',
        // '639902996173-ibdlgtsd6vloj1o519fqqeomaaplkqm9.apps.googleusercontent.com',
        callback: (response) => {
          const googleAcccessToken = response.credential

          // if (this.$cookies.get('atag')) {
          //   atag= this.$cookies.get('atag') || '';
          //   // atag = localStorage.getItem('atag')
          // }
          // if (this.$cookies.get('clickId')) {
          //   clickId= this.$cookies.get('clickId') || ''
          //   // clickId = localStorage.getItem('clickId')
          // }
          const data = {
            token: googleAcccessToken,
            atag: atag,
            clickId: clickId,
            visitorId: this.$store.state.profile.fingerprintId,
            userAgent: navigator.userAgent,
            fbc: this.$cookies.get('_fbc')
          }
          //call api to login
          // this.$axios
          //   .post(url, data)
          service
            .apiCallWithUserManagement('/auth/glogin', data)
            .then(async (res) => {
              const token = res.headers['authorization']
              const decodedToken = jwtDecode(token)
              this.createOneSignalUser(decodedToken, false)
              if (res?.data.status.statusCode == '0') {
                // localStorage.setItem('ROYALTOKEN_KEY',JSON.stringify(token));
                localStorage.setItem(
                  'userData',
                  JSON.stringify(res?.data.result)
                )
                localStorage.setItem('loginName', res?.data.result.loginName)
                localStorage.setItem('Member_code', res?.data.result.memberCode)
                localStorage.setItem(
                  'betstack',
                  res?.data?.result?.settings.presetStakeSettings?.settings
                )
                await this.allProcess(res)
                // this.router.navigate(['/'])
                //navigate to home page
                // await this.$store.commit('profile/set_login', true);
                // console.log('from glogin fn', this.$auth.loggedIn);
                window.location.href = '/'
                // window.location.reload()
              }
            })
            .catch((err) => {
              console.log('from glogin fn', err)
            })
        },
        auto_select: false,
        ux_mode: 'popup'
      })
      this.googleButtonWrapper = createGoogleWrapper()
      this.googleButtonWrapper.click()
      function createGoogleWrapper() {
        const btn = document.createElement('div')
        btn.style.display = 'none'
        btn.classList.add('custom-google-button')
        // console.log(btn)
        document.body.appendChild(btn)
        google.accounts.id.renderButton(btn, {
          theme: 'outline',
          size: 'large',
          text: 'continue_with',
          width: '100%'
        })
        const googleLoginWrapper = btn.querySelector('div[role=button]')
        return {
          click: () => {
            googleLoginWrapper.click()
          }
        }
      }
    },
    gloginPost: (response) => {
      const token = response.credential
      if (localStorage.getItem('atag')) {
        this.atag = localStorage.getItem('atag')
      }
      if (localStorage.getItem('clickId')) {
        this.clickId = localStorage.getItem('clickId')
      }
      const data = {
        token: token,
        atag: this.atag,
        clickId: this.clickId
      }
      console.log('from glogin fn', response)
    },

    goToWhatsapp() {
      if (
        this.getWhatsappData?.isWhatsAppNo &&
        this.getWhatsappData.whatsAppLink
      ) {
        return this.getWhatsappData.whatsAppLink
      }
    },
    getJoinNowEvent() {
      eventScript.calledJoinNowEventScript()
      if (
        this.$route?.query?.btag &&
        constants.digiMazeOutbrain === this.$route.query.btag
      ) {
        eventScript.joinNowBtnDigimaze()
      }
    },
    // blockUserIp() {
    //   this.$store.dispatch('ip/blockUserIp')
    // },
    onSelect(data) {
      this.countryCode = data.dialCode
    },
    showSnackbar({ content, color }) {
      this.$store.commit('snackbar/open', {
        text: content,
        color
      })
    },
    async login() {
      // let recaptchaToken = 'null'
      const loginEventId = 'o91gt1Q0PK'
      await this.$store.dispatch(
        'userBalance/saveEventIdToLocalStorage',
        loginEventId
      )
      // if (constants.captchaOn && !this.$route.query.user) {
      //   try {
      //     recaptchaToken = await this.$recaptcha.getResponse()
      //     await this.$recaptcha.reset()
      //   } catch (error) {
      //     console.log('Error with recaptcha : ', error)
      //   }
      // }
      if (!this.$route.query || !this.$route.query.user) {
        localStorage.clear()
        sessionStorage.clear()
      }
      if (
        !this.$route.query.login &&
        !this.$route.query.login === 'autologin'
      ) {
        this.$refs.loginForm.validate()
        if (!this.$refs.loginForm.validate()) {
          return
        }
      } else if (this.selectedOption === 'Mobile No') {
        if (this.form.userName.length < 10) {
          this.showSnackbar({
            content: 'Mobile No. should be of 10 digits',
            color: 'error'
          })
          return
        }
        if (this.form.userName.length > 10) {
          this.showSnackbar({
            content: 'Mobile No. should be of 10 digits',
            color: 'error'
          })
          return
        }
        if (this.version.projectCode === 'bd') {
          this.countryCode = '880'
        } else {
          this.countryCode = '91'
        }
      } else if (this.selectedOption === 'User ID') {
        this.countryCode = null
      }
      if (this.form.userName) {
        // this.form.userName = this.form.userName.toLowerCase()
        try {
          if (
            this.ipBlock?.data?.data &&
            this.ipBlock.data.status &&
            this.ipBlock.data.status !== 200
          ) {
            this.showSnackbar({
              content:
                this.ipBlock.data.message ||
                'Error code 507, Please contact admin',
              color: 'error'
            })
            return
          }
          this.loading = true
          this.form.countryCode = this.countryCode
          this.form.visitorId = this.$store.state.profile.fingerprintId
          this.form.fbc = this.$cookies.get('_fbc')
          this.form.userAgent = navigator.userAgent
          // const token = await this.$recaptcha.getResponse()
          // console.log('ReCaptcha token:', token)
          // await this.$recaptcha.reset()
          // this.loading = true
          // this.form.password = encryptor.encrypt(this.form.password)
          // this.form.captcha = this.form.captcha
          //   ? this.form.captcha
          //   : recaptchaToken
          // this.form.captcha = recaptchaToken

          // if (
          //   this.setUp === 'fps' &&
          //   isNaN(this.form.userName) &&
          //   !this.form.userName.includes('@fairplaysports.co$fpsp')
          // ) {
          //   this.form.userName = this.form.userName + '@fairplaysports.co$fpsp'
          // }
          // this.form.userName = parseInt(this.form.userName)
          const user = await this.$store.dispatch(
            'authenticate/login',
            this.form
            // token
          )
          this.loading = false
          if (!user) {
            this.showSnackbar({ content: 'Please try again', color: 'error' })
            this.$store.commit('authenticate/set_error', null)
            return
          } else if (
            user.data &&
            user.status &&
            user.status === 200 &&
            user.data.result
          ) {
            await this.allProcess(user)
          } else if (user.data && user.data.error) {
            if (
              user.data.error.data &&
              user.data.error.data === 'User not found' &&
              this.setUp === 'gb'
            ) {
              await this.checkAnotherTMforThisUser()
            } else {
              if (user.data.error) {
                // console.log('useruseruser', user)

                this.showSnackbar({
                  content: user.data.error,
                  color: 'error'
                })
                this.$store.commit('authenticate/set_error', null)
                // break
              }
              if (
                user.data.error.verifyUser &&
                user.data.error.verifyUser == true
              ) {
                if (user.data.error.user && user.data.error.user.mobileNo) {
                  user.data.error.form = this.form
                  this.step = 'confirmRegistrationForm'
                  this.$store.commit('authenticate/set_error', user.data.error)
                  this.confirmForm.mobileNo = user.data.error.user.mobileNo
                  this.checkVerifySmsProcess()
                } else {
                  user.data.error.form = this.form
                  this.$store.commit('authenticate/set_error', user.data.error)
                }
              }
              return
            }
          } else {
            this.showSnackbar({ content: 'Please try again', color: 'error' })
            this.$store.commit('authenticate/set_error', null)
            return
          }
        } catch (err) {
          this.showSnackbar({
            content: err.message || 'No Internet Connection. Please Try Again.',
            color: 'error'
          })
        } finally {
          this.loading = false
        }
      } else {
        this.showSnackbar({
          content: 'Email/Mobile No Required',
          color: 'error'
        })
      }
    },

    async allProcess(user) {
      this.loading = true
      if (localStorage && localStorage.getItem('accessToken')) {
        localStorage.removeItem('accessToken')
      }
      if (this.form.checked) {
        const cookie = this.form
        cookie.countryCode = encryptor.encrypt(cookie.countryCode)
        cookie.userName = encryptor.encrypt(cookie.userName)
        cookie.password = encryptor.encrypt(cookie.password)
        document.cookie = `countryCode=${cookie.countryCode}; secure; samesite=strict`
        document.cookie = `userName=${cookie.userName}; secure; samesite=strict`
        document.cookie = `password=${cookie.password}; secure; samesite=strict`
      } else {
        document.cookie = `countryCode=; secure; samesite=strict; max-age=0`
        document.cookie = `userName=; secure; samesite=strict; max-age=0`
        document.cookie = `password=; secure; samesite=strict; max-age=0`
      }
      localStorage.setItem('accessToken', user?.headers?.authorization)
      // console.log('first user', user)
      //user.data.result.userProfile.MEMBER_CODE
      await this.$store.dispatch(
        'profile/getLoyaltyData',
        user?.data?.result?.userProfile?.MEMBER_CODE
      )
      localStorage.setItem(
        'memberCode',
        user?.data?.result?.userProfile?.MEMBER_CODE
      )
      localStorage.setItem('userRes', encryptor.encrypt(JSON.stringify(user)))
      await this.$store.dispatch('profile/getProfile', user)
      if (user.data.result && user?.headers?.authorization) {
        await this.normalLogin(user)
      } else if (
        user.data.data &&
        user.data.data.play &&
        user.data.data.play.error
      ) {
        this.loading = false
        this.showSnackbar({
          content: user.data.data.play.error || 'Internal Server Error',
          color: 'error'
        })
        return
      } else {
        this.loading = false
        this.showSnackbar({
          content: 'Internal Server Error',
          color: 'error'
        })
        return
      }
      //One Signal Device ID Stored Start
      try {
        const OS = window.OneSignal
        if (OS) {
          const deviceId = await OS.getUserId()
          await this.$store.dispatch('fairplayLogin/saveUserDeviceId', {
            deviceId: deviceId ? deviceId : ''
          })
        }
      } catch (error) {}
      //One Signal Device ID Stored End
      // await this.playLogin(savedUserData.data)
      // @@@@@@@@@@@
      if (this.readyToSubmit) {
        await this.saveQuizAnswers(user.data.data.amplify)
      } else {
        this.loading = false
      }
      localStorage.removeItem('fairplay_affilates')
      if (process.env.fairplayEnvironment === 'PROD') {
        this.sportsRadarLoginEvent({
          id: user.data.data.amplify._id
        })
      }
      this.loading = false
    },

    async checkAnotherTMforThisUser() {
      try {
        this.loading = true
        // if (
        //   isNaN(this.form.userName) &&
        //   !this.form.userName.includes('@fairplaysports.co$fpsp')
        // ) {
        //   this.form.userName = this.form.userName + '@fairplaysports.co$fpsp'
        // }
        const user = await this.$store.dispatch(
          'authenticate/loginAnotherDomain',
          this.form
        )
        this.loading = false
        if (!user) {
          this.showSnackbar({ content: 'Please try again', color: 'error' })
          this.$store.commit('authenticate/set_error', null)
          return
        } else if (user.data && user.data.status && user.data.status === 200) {
          let abc = await encryptor.encrypt(JSON.stringify(user))
          abc = abc.replaceAll('+', '@')
          window.location.replace(
            `${process.env.frontendDomainUrl}/login/?user=${abc}`
          )
        } else if (user.data && user.data.error) {
          if (user.data.error) {
            console.log('useruseruser', user)

            this.showSnackbar({
              content: user.data.error,
              color: 'error'
            })
            this.$store.commit('authenticate/set_error', null)
            // break
          }
          if (
            user.data.error.verifyUser &&
            user.data.error.verifyUser == true
          ) {
            if (user.data.error.user && user.data.error.user.mobileNo) {
              user.data.error.form = this.form
              this.step = 'confirmRegistrationForm'
              this.$store.commit('authenticate/set_error', user.data.error)
              this.confirmForm.mobileNo = user.data.error.user.mobileNo
              this.checkVerifySmsProcess()
            } else {
              user.data.error.form = this.form
              this.$store.commit('authenticate/set_error', user.data.error)
            }
          }
          return
        } else {
          this.loading = false
          this.showSnackbar({ content: 'Please try again', color: 'error' })
          this.$store.commit('authenticate/set_error', null)
          return
        }
      } catch (error) {
        this.loading = false
        console.log('error', error)
      }
    },
    checkVerifySmsProcess() {
      if (this.verifySms) {
        this.confirmForm.code = ''
      } else {
        try {
          this.confirmForm.code = this.verifyStandardOTP
          if (document) {
            const abc = document.getElementById('confirmBtn')
            abc.onclick = this.confirmRegristration()
          }
        } catch (error) {
          console.log('error')
        }
      }
    },

    sportsRadarLoginEvent(data) {
      if (constants.removeSportsRadar) {
        try {
          srtmCommands.push({
            event: 'track.user.login',
            payload: {
              action: 'complete',
              userId: data.id
            }
          })
        } catch (err) {
          console.log(err)
        }
      }
    },

    getCookie(name) {
      var cookieArr = document.cookie.split(';')
      for (var i = 0; i < cookieArr.length; i++) {
        if (cookieArr[i].includes('password=')) {
          var cookiePair = cookieArr[i].split('password=')
          cookiePair[0] = 'password'
        } else if (cookieArr[i].includes('userName=')) {
          var cookiePair = cookieArr[i].split('userName=')
          cookiePair[0] = 'userName'
        } else if (cookieArr[i].includes('countryCode=')) {
          var cookiePair = cookieArr[i].split('countryCode=')
          cookiePair[0] = 'countryCode'
        } else {
          var cookiePair = cookieArr[i].split('=')
        }
        if (name == cookiePair[0].trim()) {
          return cookiePair[1]
        }
      }
      return null
    },

    checkCookie() {
      var countryCode = this.getCookie('countryCode')
      var userName = this.getCookie('userName')
      var password = this.getCookie('password')
      const decryptUserName = encryptor.decrypt(userName)
      const decryptPassword = encryptor.decrypt(password)
      const decryptCountryCode = encryptor.decrypt(countryCode)
      if (countryCode != null && userName != null && password != null) {
        this.form.countryCode = decryptCountryCode
        this.form.userName = decryptUserName
        this.form.password = decryptPassword
        this.form.checked = true
      }
    },
    checkUserCredentialsFromURL() {
      try {
        if (this.$route.query.user) {
          let timePass = this.$route.query.user
          timePass = timePass.replaceAll(' ', '')
          timePass = timePass.replaceAll('@', '+')
          const userObj = JSON.parse(encryptor.decrypt(timePass))
          if (userObj) {
            this.allProcess(userObj)
          }
        } else if (this.$route.query.username && this.$route.query.password) {
          this.form.userName = window.atob(this.$route.query.username)
          this.form.password = window.atob(this.$route.query.password)
          this.form.checked = true
          if (
            this.$route.query.login &&
            this.$route.query.login === 'autologin'
          ) {
            document.getElementById('loginBtn').onclick = this.login()
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    },

    // onSuccess(token) {
    //   console.log('Succeeded:', token)
    // },
    // onExpired() {
    //   console.log('Expired')
    // },
    // onError(error) {
    //   console.log('Error happened:', error)
    // },
    async confirmRegristration() {
      if (this.verifySms) {
        this.$refs.confirmRegistrationForm.validate()
        if (!this.$refs.confirmRegistrationForm.validate()) {
          return
        }
      }
      try {
        // this.confirmForm.countryCode = this.countryCode
        this.loading = true
        let verifyMobileData = await this.$store.dispatch(
          'authenticate/confirmVerifyMobile',
          this.confirmForm
        )
        this.loading = false

        if (!verifyMobileData) {
          this.showSnackbar({ content: 'Please try again', color: 'error' })
          this.$store.commit('authenticate/set_error', null)
        } else if (
          verifyMobileData.data &&
          verifyMobileData.data.status &&
          verifyMobileData.data.status === 200
        ) {
          this.showSnackbar({
            content: verifyMobileData.data.data
              ? verifyMobileData.data.data
              : `User Verified. Please login!!!`,
            color: 'success'
          })
          this.step = 'login'
          this.form = { userName: '', password: '', checked: false }
          this.$store.commit('authenticate/set_error', null)
        } else if (verifyMobileData.data && verifyMobileData.data.error) {
          for (const x in verifyMobileData.data.error) {
            this.showSnackbar({
              content: verifyMobileData.data.error[x] || 'Please try again',
              color: 'error'
            })
            this.$store.commit('authenticate/set_error', null)
          }
        } else {
          this.showSnackbar({ content: 'Please try again', color: 'error' })
          this.$store.commit('authenticate/set_error', null)
        }
      } catch (err) {}
    },
    async saveQuizAnswers(savedUserData) {
      const dataToSend = {
        userId: savedUserData._id,
        predictions: this.predictions
      }
      const res = await this.$store.dispatch(
        'contest/saveUserPredictions',
        dataToSend
      )
      if (
        res &&
        res.status === 200 &&
        res.data === 'Contest Answers Saved Successfully.'
      ) {
        this.$router.push('/thank-you')
      } else if (res && res.status === 200 && res.data === 'Already answered') {
        this.showSnackbar({
          content: 'Predictions already saved',
          color: 'info'
        })
        this.$router.push('/')
      } else {
        this.showSnackbar({
          content: 'No Internet Connection while saving predictions',
          color: 'error'
        })
        this.$router.push('/')
      }
    },
    async resendCode() {
      // this.confirmForm.countryCode = this.countryCode
      const resentOtp = await this.$store.dispatch(
        'authenticate/resendOtpmobileForSignup',
        this.confirmForm
      )
      if (!resentOtp) {
        this.showSnackbar({ content: 'Please try again', color: 'error' })
        this.$store.commit('authenticate/set_error', null)
        return
      } else if (
        resentOtp.data &&
        resentOtp.data.status &&
        resentOtp.data.status === 200
      ) {
        // this.step = 'confirmRegistrationForm'
        this.confirmForm.mobileNo = resentOtp.data.user.mobileNo
        this.showSnackbar({
          content: resentOtp.data.data
            ? resentOtp.data.data
            : `Code sent to ${this.confirmForm.mobileNo} `,
          color: 'success'
        })
        return
      } else if (resentOtp.data && resentOtp.data.error) {
        for (const x in resentOtp.data.error) {
          this.showSnackbar({
            content: resentOtp.data.error[x] || 'Please try again',
            color: 'error'
          })
          this.$store.commit('authenticate/set_error', null)
        }
        return
      } else {
        this.showSnackbar({ content: 'Please try again', color: 'error' })
        this.$store.commit('authenticate/set_error', null)
        return
      }
    },
    async normalLogin(playData) {
      const json = {
        accessToken: playData?.headers?.authorization
      }
      try {
        await this.$auth.loginWith('customLocal', {
          baseURL: process.env.BASE_URL,
          data: json
        })
        this.$auth.setUser({ ...playData.data.result })
        await Promise.all([this.$store.dispatch('settings/getUserConfig')])
        let redirectUrl
        if (this.$route.query?.redirectUrl) {
          redirectUrl = this.$route.query.redirectUrl
        } else {
          redirectUrl = '/'
        }
        this.showSnackbar({
          content: 'Logged in successfully.',
          color: 'success'
        })
        this.loading = false
        this.$router.push(redirectUrl)
      } catch (error) {
        this.loading = false
        if (error?.response?.data?.error) {
          this.$store.commit('snackbar/open', {
            text: error.response.data.error,
            color: 'error'
          })
        } else {
          this.$store.commit('snackbar/open', {
            text: 'Invalid credentials, please try again!',
            color: 'error'
          })
        }
      }
    },
    onError(error) {
      // console.log('Error happened:', error)
    },
    onSuccess(token) {
      // console.log('Succeeded:', token)
    },
    onExpired() {
      window.location.reload()
    }
  },

  head() {
    return {
      title:
        'FairPlay’s Online Games and Live Sports | Login to Your Account Today',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Dive into the world of authentic gambling and betting – FairPlay. We provide the most platform for you to have the most fun in a safe and responsible gaming environment.`
        },
        {
          name: 'keywords',
          content: `Login to your account`
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.v-label {
  top: 2px !important;
}
.line-height .v-text-field__slot label {
  line-height: 28px;
}
.btn-hightlight {
  background: #334634;
}
.login-with-btn {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.login {
  min-width: 48% !important;
  // background: #000c24 !important;
  // border: 1px solid #1f2937;
  background: #fff !important;
  border: 1px solid #f36c21;
  border-radius: 6px;

  > span {
    color: #000 !important;
    text-transform: capitalize;
    font-size: 15px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
  }
}
.whatsup-icon {
  width: 20px;
  height: 20px;
}
.login-with {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  padding: 8px 0px;

  > span {
    gap: 5px;
    width: 100%;
    color: #d5d9de;
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.01875rem;
  }
}
.line {
  width: 100%;
  align-items: center;
  display: flex;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}
.v-btn__content {
  // flex: 0 0 0 !important;
  gap: 2px;
  justify-content: inherit;
}
.select-box {
  width: 20%;
}
.select-box input {
  display: none;
}
// .v-text-field {
//   height: 70px;
// }
.input-text {
  width: 80%;
}
.v-select__slot {
  height: 34px;
}
.align-gap {
  gap: 2px;
}
.my-1 {
  width: 4%;
}
.v-input input {
  max-height: 34px;
}
.v-list-item__content {
  padding: 0px !important;
  flex: 1 1 auto !important;
}
.v-responsive {
  flex: 0 0 auto !important;
}

.google-text {
  text-transform: capitalize;
  font-size: 14px;
  color: #000;
  margin-left: 4px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;
}

@media (max-width: 345px) {
  .select-box {
    width: 38%;
  }
  .login-with-btn {
    > .login {
      padding: 0px !important;
    }
  }
  .login span {
    font-size: 10px;
  }
}
</style>
